export type THoursOfOperation = {
  className?: string;
  label: string;
  // https://schema.org/openingHours
  machineReadable: string;
};

export default function HoursOfOperation({
  className,
  label,
  machineReadable,
}: THoursOfOperation) {
  return (
    <>
      <span className={className}>{label}</span>
      <meta itemProp="openingHours" content={machineReadable} />
    </>
  );
}
